import React from "react";
import { FaBuilding } from "react-icons/fa";
import SearchBar from "../SearchBar/SearchBar";
import DashMedidasSectionCard from "../../pages/DashMedidas/components/DashMedidasSectionCard/DashMedidasSectionCard";
import "./SguUnitsMenu.css";

/**
 * Shell padrão do menu lateral (card + busca + lista + empty).
 */
const SguUnitsSideMenu = ({
  icon,
  subtitle = "Seleção",
  title = "Unidades",
  headerRight,
  sectionId,
  collapsible = false,
  searchValue,
  onSearch,
  showSearch = true,
  toolbarExtra = null,
  emptyText = "Nenhuma unidade encontrada",
  emptyIcon: EmptyIcon = FaBuilding,
  children,
  listRef,
  bodyClassName = "",
  className = "",
  scrollClassName = "",
  loading = false,
  loadingText = "Atualizando...",
}) => {
  const hasItems = React.Children.count(children) > 0;

  return (
    <DashMedidasSectionCard
      icon={icon}
      subtitle={subtitle}
      title={title}
      headerRight={headerRight}
      collapsible={collapsible}
      sectionId={sectionId}
      className={["sgu-units-side-menu", className].filter(Boolean).join(" ")}
      bodyClassName={["sgu-units-body", "sgu-units-menu-body", bodyClassName]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="sgu-units-menu-toolbar">
        {showSearch && typeof onSearch === "function" ? (
          <div className="sgu-units-search">
            <SearchBar onSearch={onSearch} searchData={searchValue} />
          </div>
        ) : null}
        {toolbarExtra}
      </div>

      <div
        className={["sgu-units-scroll", "scroll", "scrollbar", scrollClassName]
          .filter(Boolean)
          .join(" ")}
        ref={listRef}
      >
        {loading ? (
          <div className="sgu-units-menu-loading">
            <div className="spinner-border sgu-units-menu-loading__spinner" role="status" />
            <p className="mb-0">{loadingText}</p>
          </div>
        ) : hasItems ? (
          <div className="sgu-units-list">{children}</div>
        ) : (
          <div className="sgu-empty-state">
            <EmptyIcon size={36} className="sgu-empty-state__icon" />
            <p className="mb-0">{emptyText}</p>
          </div>
        )}
      </div>
    </DashMedidasSectionCard>
  );
};

export default SguUnitsSideMenu;
